import { HttpRequest, HttpMethod } from "./http";

// Makro PRO / Mirakl — stock/price/offer push. Offers are sourced from the
// platform-10 product SKUs (bo_product_sku), maintained on the existing product
// page — there is no separate offer-map screen. The credential/connect methods
// live in platform.js.
class PlatformMiraklProvider extends HttpRequest {
    // POST push stock + price (STO01 + PRI01). payload: { offer_skus?: [] } (empty = all).
    // Returns { job_id } — poll via syncJob(id) on the shared Sync Log endpoint.
    offersPush(payload) {
        return this.request(HttpMethod.Post, "/api/platform/mirakl/offers/push", payload || {});
    }

    // POST single OF24 upsert (open/close one offer). payload: { offer_sku }.
    offerUpsertOne(payload) {
        return this.request(HttpMethod.Post, "/api/platform/mirakl/offers/upsert", payload);
    }

    // POST manual product sync (offer catalog pull), no body. Returns
    // { job_id, status } (200) or { job_id, status, message } (422, already
    // in flight) — poll progress via syncJob(id) / the shared sync-jobs
    // endpoint below.
    productsSync() {
        return this.request(HttpMethod.Post, "/api/platform/mirakl/products/sync", {});
    }

    // Shared sync-job progress poll (Issue #32) — same endpoint the marketplace
    // product/order syncs use.
    syncJob(id) {
        return this.request(HttpMethod.Get, `/api/platform/v2/sync/jobs/${id}`);
    }
}

export default PlatformMiraklProvider;
